import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Dotdotdot } from "../../../dotdotdot/src";
import { __ } from "../../../i18n/src";
import { Image } from "../../../image/src";
import { useMatchBreakpoint } from "../../../theme/src";
import { Title } from './Title';
export const NewsContent = ({ content, cover, threeDotActions, title, }) => {
    const isMobile = useMatchBreakpoint('s');
    return (_jsxs(NewsWrapper, { children: [_jsx(ImageWrapper, { "$isMobile": isMobile, children: _jsx(Image, { alt: __(`Image for news ${title}`), height: "100%", src: cover, style: { objectFit: 'cover' }, width: "100%" }) }), _jsxs(Box, { flex: 1, flexDirection: "column", p: { _: 4, m: 0 }, position: { _: 'relative', m: 'unset' }, children: [threeDotActions, _jsx(StyledType, { "aria-label": __('Type of content: News'), tabIndex: 0, children: __('News') }), _jsx(Title, { ariaLabel: title, isMobile: isMobile, title: title }), _jsx(Box, { lineHeight: "19px", tabIndex: 0, width: { m: '90%' }, children: _jsx(Dotdotdot, { clamp: 2, screenReaderMaxLength: 200, children: content }) })] })] }));
};
const NewsWrapper = styled(Box).attrs({
    flexDirection: { _: 'column', m: 'row' },
    alignItems: { m: 'center' },
    justifyContent: { m: 'center' },
    width: { _: '100%', m: 'auto' },
}) ``;
const ImageWrapper = styled(Box).attrs({
    height: { _: '128px', m: '69px' },
    mr: { m: 6 },
    width: { m: '186px' },
}) `
  border-radius: ${({ $isMobile }) => ($isMobile ? '0' : '10px')};
  overflow: hidden;
`;
const StyledType = styled(Box).attrs({
    fontSize: 1,
    fontWeight: 600,
}) `
  color: ${({ theme }) => theme.colors.primary};
`;
//# sourceMappingURL=NewsContent.js.map